// src/components/JoinCommunity.jsx
import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  HStack,
  Input,
  Button,
  useToast,
} from "@chakra-ui/react";
import Translate from "../LanguageTranslation/Translate"; // adjust path if needed
import axiosInstance from "../../helpers/axiosInstance";

const JoinCommunity = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const placeholderText = "john.doe@email.com";

  const handleSubscribe = async () => {
    if (!email) {
      console.error("Email is required");
      return;
    }

    setIsLoading(true); // Start loading
    try {
      const response = await axiosInstance.post("/newsletter/", { 
        email, 
        is_manual: true,
        date: new Date().toISOString()
      });
      if (response.status === 201) {
        setEmail(""); // Clear the email input after successful submission
      } else {
        console.error("Subscription failed");
      }
    } catch (error) {
      console.error("Error subscribing to newsletter:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  return (
    <Box
      mt={12}
      p={8}
      pb={8}               // <- fixed “pb” prop
      bg="#F7F7F7"
      borderRadius="lg"
      textAlign="center"
    >
      <Heading as="h2" size="lg" mb={4}>
        <Translate text="Join the Green & Wild Community!" />
      </Heading>

      <Text
        mb={6}
        w={{ base: "100%", md: "50%" }}
        mx="auto"
        textAlign="center"
      >
        <Translate text="Subscribe to NOMAD360 newsletter for personalized travel tips, epic outdoor experiences, and exclusive offers. Connect with fellow explorers and start planning your next adventure today!" />
      </Text>

      <HStack
        maxW="500px"
        mx="auto"
        p={2}
        borderRadius="md"
        bg="white"
        boxShadow="sm"
        spacing={4}
      >
        <Input
          type="email"
          placeholder={placeholderText}
          variant="unstyled"
          px={4}
          flex="1"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          bg="black"
          color="white"
          px={6}
          _hover={{ transform: "scale(1.05)", bg: "black" }}
          isLoading={isLoading}
          onClick={handleSubscribe}
        >
          <Translate text="Subscribe" />
        </Button>
      </HStack>
    </Box>
  );
};

export default JoinCommunity;
